<template>
    <div class="wayeal-home" :style="{ marginTop: this.GLOBAL.isMobile ? '60px' : '0' }">
        <section class="hero" @mouseenter="pauseHero" @mouseleave="startHero">
            <el-carousel ref="hero" :autoplay="false" :height="heroHeight" arrow="never" indicator-position="none" @change="onHeroChange">
                <el-carousel-item v-for="(item, index) in heroList" :key="item.id || index">
                    <div class="hero-item">
                        <img class="hero-bg" :src="item.imageUrl" :alt="item.title"/>
                        <!-- <div class="hero-mask"></div>-->
                        <div class="wrap hero-text" :class="{ 'text-dark': heroTextDark }">
                            <p>{{ item.subtitle }}</p>
                            <h2>{{ item.title }}</h2>
                            <i></i>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
            <!-- 左箭头 -->
            <button type="button" class="hero-arrow hero-arrow-left" :class="{ 'arrow-dark': heroTextDark }" @click="prevHero"></button>
            <!-- 圆点指示器 -->
            <div class="hero-dots-bar">
                <div class="dots">
                    <button
                        v-for="(item, index) in heroList"
                        :key="`dot-${index}`"
                        type="button"
                        :class="{ active: heroIndex === index }"
                        @click="goHero(index)"
                    ></button>
                </div>
            </div>
            <!-- 右箭头 -->
            <button type="button" class="hero-arrow hero-arrow-right" :class="{ 'arrow-dark': heroTextDark }" @click="nextHero"></button>
        </section>

        <section class="product observe" data-name="product">
            <div class="wrap">
                <div class="tabs">
                    <button
                        v-for="(tab, index) in productTabs"
                        :key="tab.id || index"
                        type="button"
                        :class="{ active: productTabIndex === index }"
                        @click="switchTab(index)"
                    >
                        {{ tab.name }}
                    </button>
                </div>
                <div class="product-panel" @mouseenter="pauseProduct" @mouseleave="startProduct">
                    <transition name="fade-y" mode="out-in">
                        <div v-if="currentProduct" :key="currentProduct.id || productIndex" class="left">
                            <p class="model">{{ currentProduct.model }}</p>
                            <h3>{{ currentProduct.title }}</h3>
                            <div class="point" v-for="(line, idx) in currentProduct.features" :key="idx">
                                <svg class="point-icon" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                                    <polygon points="6,0 12,6 6,12 0,6" fill="#3675D9"/>
                                </svg>
                                <span>{{ line }}</span>
                            </div>
                            <a class="more" :href="toLink(currentProduct.link)" target="_blank" rel="noopener">了解更多 +</a>
                        </div>
                    </transition>
                    <!-- 右侧图片区（背景容器固定，仅内容淡入淡出） -->
                    <div class="right">
                        <transition name="fade-y" mode="out-in">
                            <div v-if="currentProduct" :key="`${currentProduct.id || productIndex}-img`" class="img-content">
                                <img :src="currentProduct.imageUrl" :alt="currentProduct.title"/>
                            </div>
                        </transition>
                        <button type="button" class="img-arrow img-arrow-left" @click="prevProduct"></button>
                        <button type="button" class="img-arrow img-arrow-right" @click="nextProduct"></button>
                        <div class="img-counter" v-if="currentProduct">
                            {{ productIndex + 1 }} / {{ currentProducts.length }}
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="solution observe" data-name="solution" :style="{ backgroundImage: `url(${currentSolution.backgroundImage})` }">
            <div class="mask">
                <div class="wrap">
                    <div class="head">
                        <div>
                            <h2>{{ solutionBlock.title }}</h2>
                            <h3>{{ solutionBlock.subtitle }}</h3>
                        </div>
                        <div class="switcher">
                            <button
                                v-for="(item, index) in solutionBlock.items"
                                :key="item.id || index"
                                type="button"
                                :class="{ active: solutionIndex === index }"
                                @click="solutionIndex = index"
                            >
                                {{ item.name }}
                            </button>
                        </div>
                    </div>
                    <div class="card">
                        <h4>{{ currentSolution.name }}</h4>
                        <ul>
                            <li v-for="(line, index) in currentSolution.lines" :key="index">{{ line }}</li>
                        </ul>
                        <a class="more white" :href="toLink(currentSolution.link)" target="_blank" rel="noopener">了解更多 +</a>
                    </div>
                </div>
            </div>
        </section>

        <section class="about observe" data-name="about">
            <div class="wrap grid">
                <div class="desc" :class="{ 'desc-cn': isChineseLocale }">
                    <h2>{{ aboutBlock.title }}</h2>
                    <h3>{{ aboutBlock.subtitle }}</h3>
                    <p v-for="(line, index) in aboutBlock.description" :key="`about-line-${index}`">{{ line }}</p>
                    <a class="more" :href="toLink(aboutBlock.moreLink)" target="_blank" rel="noopener">了解更多 +</a>
                </div>
                <div class="stats">
                    <div class="stat" v-for="(item, index) in aboutBlock.stats" :key="item.id || index">
                        <p>{{ statView[index] }}<span>{{ item.unit }}</span></p>
                        <small>{{ item.label }}</small>
                    </div>

                </div>
            </div>
            <div v-if="GLOBAL.isMobile" class="mobile-contact observe">
                <a href="tel:15910967510" class="mobile-contact-card">
                    <div class="mobile-contact-icon">
                        <img src="../assets/mobile_menu_tel_white.svg" alt="电话" width="32px"/>
                    </div>
                    <div class="mobile-contact-info">
                        <span class="mobile-contact-label">{{ $t('index_23') }}</span>
                        <span class="mobile-contact-phone">15910967510</span>
                    </div>
                    <div class="mobile-contact-arrow"></div>
                </a>

                <!-- 底部：备案号 -->
                <div class="footer-icp">
                    <a target="_blank"  href="https://www.amap.com/ssr/search?query=北京市昌平区沙河新飞达科技发展中心F6-3">{{$t('index_28_1')}}</a>
                    <span> · </span>
                    <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">京ICP备18042055号</a>
                </div>
            </div>
        </section>



    </div>
</template>

<script>
import axios from '@/utils/axios'

export default {
    data() {
        return {
            heroList: [],
            heroIndex: 0,
            productTabs: [],
            productTabIndex: 0,
            productIndex: 0,
            solutionBlock: {title: '', subtitle: '', items: []},
            solutionIndex: 0,
            statView: [],
            heroTimer: null,
            productTimer: null,
            statTimer: null,
            observer: null,
            statAnimated: false,
            heroTextDark: false,
        }
    },
    computed: {
        heroHeight() {
            return this.GLOBAL.isMobile ? '68vw' : '100vh'
        },
        currentProducts() {
            const tab = this.productTabs[this.productTabIndex]
            return tab && tab.items ? tab.items : []
        },
        currentProduct() {
            const list = this.currentProducts
            if (!list.length) return null
            const idx = Math.min(this.productIndex, list.length - 1)
            return list[idx]
        },
        currentSolution() {
            return this.solutionBlock.items[this.solutionIndex] || {name: '', lines: [], link: '', backgroundImage: ''}
        },
        isChineseLocale() {
            const locale = this.$i18n && this.$i18n.locale ? String(this.$i18n.locale).toUpperCase() : 'CN'
            return locale === 'CN'
        },
        aboutBlock() {
            return {
                title: this.$t('home_about_title'),
                subtitle: this.$t('home_about_subtitle'),
                description: String(this.$t('home_about_description') || '').split('\n').filter((item) => item),
                moreLink: '/#/companyInfo?type=GSJJ',
                stats: [
                    {id: 'a1', value: Number(this.$t('home_about_stat1_value')), unit: this.$t('home_about_stat1_unit'), label: this.$t('home_about_stat1_label')},
                    {id: 'a2', value: Number(this.$t('home_about_stat2_value')), unit: this.$t('home_about_stat2_unit'), label: this.$t('home_about_stat2_label')},
                    {id: 'a3', value: Number(this.$t('home_about_stat3_value')), unit: this.$t('home_about_stat3_unit'), label: this.$t('home_about_stat3_label')},
                ]
            }
        }
    },
    methods: {
        toLink(link) {
            return link
        },
        onHeroChange(index) {
            this.heroIndex = index
            const slide = this.heroList[index]
            if (slide) this.analyzeBrightness(slide.imageUrl)
        },
        goHero(index) {
            if (!this.heroList.length) return
            const next = (index + this.heroList.length) % this.heroList.length
            this.heroIndex = next
            if (this.$refs.hero) this.$refs.hero.setActiveItem(next)
        },
        nextHero() {
            this.goHero(this.heroIndex + 1)
        },
        prevHero() {
            this.goHero(this.heroIndex - 1)
        },
        startHero() {
            this.pauseHero()
            if (this.heroList.length <= 1) return
            this.heroTimer = setInterval(() => this.nextHero(), 4500)
        },
        pauseHero() {
            clearInterval(this.heroTimer)
            this.heroTimer = null
        },
        switchTab(index) {
            this.productTabIndex = index
            this.productIndex = 0
            this.startProduct()
        },
        nextProduct() {
            if (!this.currentProducts.length) return
            this.productIndex = (this.productIndex + 1) % this.currentProducts.length
        },
        prevProduct() {
            if (!this.currentProducts.length) return
            this.productIndex = (this.productIndex - 1 + this.currentProducts.length) % this.currentProducts.length
        },
        startProduct() {
            this.pauseProduct()
            if (this.currentProducts.length <= 1) return
            this.productTimer = setInterval(() => this.nextProduct(), 3500)
        },
        pauseProduct() {
            clearInterval(this.productTimer)
            this.productTimer = null
        },
        runCounter() {
            if (this.statAnimated) return
            this.statAnimated = true
            const target = this.aboutBlock.stats.map((s) => Number(s.value) || 0)
            let step = 0
            const max = 40
            clearInterval(this.statTimer)
            this.statTimer = setInterval(() => {
                step += 1
                this.statView = target.map((x) => (step >= max ? x : Math.round((x * step) / max)))
                if (step >= max) {
                    clearInterval(this.statTimer)
                    this.statTimer = null
                }
            }, 28)
        },
        initObserve() {
            this.$nextTick(() => {
                const nodes = this.$el.querySelectorAll('.observe')
                if (typeof IntersectionObserver === 'undefined') {
                    nodes.forEach((n) => n.classList.add('show'))
                    this.runCounter()
                    return
                }
                if (this.observer) this.observer.disconnect()
                this.observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            if (entry.isIntersecting) {
                                entry.target.classList.add('show')
                                if (entry.target.dataset.name === 'about') this.runCounter()
                            }
                        })
                    },
                    {threshold: 0.18}
                )
                nodes.forEach((n) => this.observer.observe(n))
            })
        },
        analyzeBrightness(imageUrl) {
            if (!imageUrl) return
            const img = new Image()
            img.crossOrigin = 'anonymous'
            img.onload = () => {
                try {
                    const canvas = document.createElement('canvas')
                    const ctx = canvas.getContext('2d')
                    // 只采样图片顶部 20%，缩放到 100×10 便于快速计算
                    canvas.width = 100
                    canvas.height = 10
                    const srcH = Math.max(1, Math.floor(img.naturalHeight * 0.2))
                    ctx.drawImage(img, 0, 0, img.naturalWidth, srcH, 0, 0, 100, 10)
                    const data = ctx.getImageData(0, 0, 100, 10).data
                    let total = 0
                    const count = data.length / 4
                    for (let i = 0; i < data.length; i += 4) {
                        total += (data[i] * 299 + data[i + 1] * 587 + data[i + 2] * 114) / 1000
                    }
                    // avg > 160：图片偏亮 → 深色文字；否则白色文字
                    this.$root.$emit('hero-nav-bright', total / count > 160)
                } catch (e) {
                    // Canvas 跨域受限，默认白色文字
                    this.$root.$emit('hero-nav-bright', false)
                }
            }
            img.onerror = () => { this.$root.$emit('hero-nav-bright', false) }
            img.src = imageUrl
        },
        applyRemote(data) {
            console.log("HomeReplicaData：", data)
            if (!data || typeof data !== 'object') return
            if (Array.isArray(data.heroList) && data.heroList.length) this.heroList = data.heroList
            if (Array.isArray(data.productTabs) && data.productTabs.length) this.productTabs = data.productTabs
            if (data.solutionBlock && Array.isArray(data.solutionBlock.items) && data.solutionBlock.items.length) this.solutionBlock = data.solutionBlock
            this.heroIndex = 0
            this.productTabIndex = 0
            this.productIndex = 0
            this.solutionIndex = 0
            this.startHero()
            this.startProduct()
            this.initObserve()
            if (this.heroList.length) this.analyzeBrightness(this.heroList[0].imageUrl)
        },
        fetchData() {
            axios
                .get('/jyy/portal/getHomeReplicaData')
                .then((res) => {
                    const data = res.data && res.data.code === 0 ? res.data : null
                    if (data) this.applyRemote(data)
                })
                .catch((err) => {
                    console.warn('[首页] 接口请求失败，使用内置数据', err && err.message)
                })
        }
    },
    mounted() {
        this.statView = this.aboutBlock.stats.map(() => 0)
        this.startHero()
        this.startProduct()
        this.initObserve()
        this.fetchData()
        this._onHeroBright = (isDark) => { this.heroTextDark = isDark }
        this.$root.$on('hero-nav-bright', this._onHeroBright)
    },
    beforeDestroy() {
        this.pauseHero()
        this.pauseProduct()
        clearInterval(this.statTimer)
        this.statTimer = null
        if (this.observer) this.observer.disconnect()
        this.$root.$off('hero-nav-bright', this._onHeroBright)
    }
}
</script>

<style lang="less" scoped>
.wayeal-home {
    --primary: #0a3569;
    --deep: #041a33;
    --text: #111c2d;
    --muted: #5c6575;
    background: linear-gradient(180deg, #f9fbff 0%, #f4f8fe 100%);
    color: var(--text);
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.wrap {
    width: min(1200px, calc(100% - 40px));
    margin: 0 auto;
}

.hero {
    position: relative;
}

.hero-item {
    position: relative;
    width: 100%;
    height: 100%;
}

.hero-bg {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.hero-mask {
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, rgba(3, 19, 44, 0.72) 0%, rgba(3, 19, 44, 0.2) 56%, rgba(3, 19, 44, 0.1) 100%);
}

.hero-text {
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    color: #fff;
    z-index: 2;
    transition: color 0.35s ease;
}

/* 图片偏亮时：文字改为深色 */
.hero-text.text-dark {
    color: var(--text);
}

.hero-text.text-dark i {
    background: linear-gradient(90deg, #1a77de 0%, #0a3569 100%);
}

/* 轮播切换后：文字向上渐入 */
.hero ::v-deep .el-carousel__item.is-active .hero-text {
    /* delay 0.4s 等 el-carousel 自身的滑入过渡结束，文字再开始动画 */
    animation: hero-text-in 0.65s cubic-bezier(0.22, 0.61, 0.36, 1) 0.4s both;
}

@keyframes hero-text-in {
    from {
        opacity: 0;
        transform: translateY(calc(-50% + 40px));
    }
    to {
        opacity: 1;
        transform: translateY(-50%);
    }
}

.hero-text p {
    margin: 0 0 12px;
    font-size: clamp(15px, 1.2vw, 22px);
}

.hero-text h2 {
    margin: 0;
    font-size: clamp(30px, 3vw, 52px);
    font-weight: 600;
}

.hero-text i {
    display: block;
    width: 70px;
    height: 3px;
    border-radius: 8px;
    margin-top: 18px;
    background: linear-gradient(90deg, #51a8ff 0%, #fff 100%);
}

/* 左右箭头：绝对定位在轮播图两侧垂直居中 */
.hero-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 3;
    width: 48px;
    height: 48px;
    padding: 0;
    border-radius: 50%;
    border: none;
    background: rgba(255, 255, 255, 0.22);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.35s ease, transform 0.22s ease;
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
}

/* CSS 画箭头，天然居中无偏移 */
.hero-arrow::before {
    content: '';
    display: block;
    width: 11px;
    height: 11px;
    border-top: 2.5px solid #fff;
    border-right: 2.5px solid #fff;
    transition: border-color 0.35s ease;
}

/* 亮图深色模式 */
.hero-arrow.arrow-dark {
    background: rgba(0, 0, 0, 0.1);
}

.hero-arrow.arrow-dark::before {
    border-top-color: rgba(20, 20, 20, 0.8);
    border-right-color: rgba(20, 20, 20, 0.8);
}

.hero-arrow.arrow-dark:hover {
    background: rgba(0, 0, 0, 0.2);
}

.hero-arrow-left {
    left: 24px;
}

.hero-arrow-left::before {
    transform: rotate(-135deg) translate(-1px, 1px);
}

.hero-arrow-right {
    right: 24px;
}

.hero-arrow-right::before {
    transform: rotate(45deg) translate(-1px, 1px);
}

.hero-arrow:hover {
    background: rgba(255, 255, 255, 0.42);
    transform: translateY(-50%) scale(1.08);
}

/* 圆点指示器栏：居中固定在底部 */
.hero-dots-bar {
    position: absolute;
    z-index: 3;
    left: 0;
    right: 0;
    bottom: 24px;
    display: flex;
    justify-content: center;
}

.dots {
    display: flex;
    gap: 8px;
}

.dots button {
    width: 30px;
    height: 4px;
    border: 0;
    border-radius: 9px;
    background: rgba(255, 255, 255, 0.45);
    cursor: pointer;
    transition: all 0.22s ease;
}

.dots button.active {
    width: 44px;
    background: #fff;
}

.product {
    padding: 72px 0 56px;
}

.tabs {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0;
    margin-bottom: 48px;
}

.tabs button {
    position: relative;
    min-height: 44px;
    padding: 0 28px 14px;
    border: none;
    border-radius: 0;
    background: transparent;
    color: #8a9ab0;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
    transition: color 0.22s ease;
    margin-bottom: -1px;
}

/* 下划线：宽度从 0 展开至完整按钮宽度，与文字对齐 */
.tabs button::after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 3px;
    background: linear-gradient(90deg, #09aeff 0%, #72f7b1 100%);
    border-radius: 1px;
    transition: width 0.2s linear;
}

.tabs button.active,
.tabs button:hover {
    color: #0a3569;
    font-weight: 600;
}

.tabs button.active::after,
.tabs button:hover::after {
    width: 100%;
}

.product-panel {
    display: grid;
    grid-template-columns: 2fr 2fr;
    gap: 60px;
    align-items: center;
    min-height: 500px;
}

.left {
    background: transparent;
    padding: 20px 0;
}

.model {
    margin: 0;
    min-height: 44px;
    color: #1e4b86;
    font-size: clamp(24px, 2vw, 38px);
    font-weight: 700;
}

.left h3 {
    margin: 10px 0 22px;
    font-size: clamp(28px, 2.1vw, 40px);
    line-height: 1.25;
    white-space: pre-line;
}

.point {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
    color: var(--muted);
    font-size: 16px;
    line-height: 1.6;
}

.point-icon {
    width: 12px;
    height: 12px;
    flex-shrink: 0;
}

.more {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 44px;
    margin-top: 18px;
    padding: 0 22px;
    border-radius: 999px;
    border: 1px solid rgba(24, 77, 147, 0.25);
    color: #184d93;
    text-decoration: none;
    font-size: 15px;
    font-weight: 600;
    transition: all 0.22s ease;
}

.more:hover {
    background: #184d93;
    border-color: #184d93;
    color: #fff;
}

.more.white {
    color: #fff;
    border-color: rgba(255, 255, 255, 0.58);
}

.more.white:hover {
    background: rgba(255, 255, 255, 0.18);
}

.right {
    position: relative;
    border-radius: 16px;
    padding: 48px 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 460px;
}

.img-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

.img-content img {
    width: min(380px, 100%);
    max-height: 320px;
    object-fit: contain;
}

.img-content p {
    margin: 12px 0 0;
    text-align: center;
    font-size: 15px;
    color: var(--muted);
}

/* 图片区两侧箭头 */
.img-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 44px;
    height: 44px;
    padding: 0;
    border-radius: 50%;
    border: none;
    background: #fff;
    box-shadow: 0 4px 16px rgba(14, 47, 94, 0.14);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.22s ease, box-shadow 0.22s ease, transform 0.22s ease;
}

.img-arrow::before {
    content: '';
    display: block;
    width: 9px;
    height: 9px;
    border-top: 2px solid #1a77de;
    border-right: 2px solid #1a77de;
    transition: border-color 0.22s ease;
}

.img-arrow-left {
    left: 14px;
}

.img-arrow-left::before {
    transform: rotate(-135deg) translate(-1px, 1px);
}

.img-arrow-right {
    right: 14px;
}

.img-arrow-right::before {
    transform: rotate(45deg) translate(-1px, 1px);
}

.img-arrow:hover {
    background: #1a77de;
    box-shadow: 0 6px 20px rgba(26, 119, 222, 0.3);
    transform: translateY(-50%) scale(1.08);
}

.img-arrow:hover::before {
    border-color: #fff;
}

/* 计数器 */
.img-counter {
    position: absolute;
    bottom: 16px;
    right: 20px;
    font-size: 14px;
    color: var(--muted);
    font-weight: 500;
    letter-spacing: 0.5px;
}

.ctrl button:hover {
    background: rgba(255, 255, 255, 0.24);
}

.solution {
    background-size: cover;
    background-position: center;
}

.mask {
    background: linear-gradient(95deg, rgba(3, 23, 47, 0.88) 0%, rgba(4, 31, 64, 0.6) 56%, rgba(3, 23, 47, 0.76) 100%);
    padding: 74px 0;
}

.head {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    align-items: flex-end;
}

.head h2 {
    margin: 0;
    color: #fff;
    font-size: clamp(30px, 2.7vw, 48px);
}

.head h3 {
    margin: 10px 0 0;
    color: rgba(255, 255, 255, 0.9);
    font-size: clamp(20px, 1.6vw, 30px);
}

.switcher {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 10px;
}

.switcher button {
    min-height: 44px;
    padding: 0 18px;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.4);
    background: rgba(255, 255, 255, 0.08);
    color: rgba(255, 255, 255, 0.92);
    cursor: pointer;
    transition: all 0.22s ease;
}

.switcher button.active,
.switcher button:hover {
    background: #fff;
    border-color: transparent;
    color: #061a34;
}

.card {
    margin-top: 28px;
    padding: 26px 28px 30px;
    border-radius: 16px;
    background: rgba(9, 32, 62, 0);
    backdrop-filter: blur(5px);
}

.card h4 {
    margin: 0;
    color: #fff;
    font-size: 24px;
}

.card ul {
    margin: 16px 0 0;
    padding: 0;
    list-style: none;
    display: grid;
    gap: 12px;
}

.card li {
    position: relative;
    padding-left: 16px;
    color: rgba(255, 255, 255, 0.93);
    line-height: 1.6;
}

.card li::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #6bc1ff;
    position: absolute;
    left: 0;
    top: 10px;
}

.about {
    padding: 76px 0;
}

.grid {
    display: grid;
    grid-template-columns: 1.1fr 0.9fr;
    gap: 22px;
}

.desc {
    background: #fff;
    border-radius: 18px;
    padding: 36px 34px;
    box-shadow: 0 14px 42px rgba(17, 43, 82, 0.09);
}

.desc h2 {
    margin: 0;
    color: #173f77;
    font-size: clamp(30px, 2.5vw, 46px);
}

.desc h3 {
    margin: 10px 0 20px;
    font-size: clamp(20px, 1.5vw, 28px);
}

.desc p {
    margin: 0;
    line-height: 1.78;
    color: #445468;
    font-size: 16px;
}

.desc.desc-cn p {
    text-indent: 2em;
}

.desc p + p {
    margin-top: 10px;
}

.stats {
    display: grid;
    gap: 14px;
}

.stat {
    background: linear-gradient(145deg, #103b72 0%, #0b2e58 65%, #082141 100%);
    color: #fff;
    border-radius: 16px;
    padding: 22px 24px;
}

.stat p {
    margin: 0;
    font-size: clamp(38px, 2.8vw, 58px);
    line-height: 1;
    font-weight: 700;
}

.stat span {
    font-size: 20px;
    margin-left: 5px;
}

.stat small {
    display: block;
    margin-top: 12px;
    color: rgba(255, 255, 255, 0.92);
}


.mobile-contact {
    margin-top: 14px;
    padding: 0 12px 24px;
}

.mobile-contact-card {
    display: flex;
    align-items: center;
    gap: 16px;
    background: linear-gradient(135deg, #3675D9 0%, #1a52b0 100%);
    border-radius: 16px;
    padding: 20px 20px;
    text-decoration: none;
    color: #fff;
    box-shadow: 0 8px 28px rgba(10, 40, 88, 0.22);
}

.mobile-contact-card:active {
    opacity: 0.88;
}

.mobile-contact-icon {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.mobile-contact-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
}

.mobile-contact-label {
    font-size: 13px;
    color: #ffffff;
}

.mobile-contact-phone {
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 1px;
}

.mobile-contact-arrow {
    width: 9px;
    height: 9px;
    border-top: 2px solid rgba(255, 255, 255, 0.7);
    border-right: 2px solid rgba(255, 255, 255, 0.7);
    transform: rotate(45deg);
    flex-shrink: 0;
}


.footer-icp {
    margin-top: 56px;
    text-align: center;
    font-size: 12px;
    color: #9eafc4;
    line-height: 1.8;
}

.footer-icp a,
.footer-icp span {
    color: #9eafc4;
    text-decoration: none;
}

.footer-icp a:hover {
    color: #3675D9;
}

.observe {
    opacity: 0;
    transform: translateY(32px);
    transition: opacity 0.7s ease, transform 0.7s ease;
}

.observe.show {
    opacity: 1;
    transform: translateY(0);
}

.fade-y-enter-active,
.fade-y-leave-active {
    transition: opacity 0.28s ease, transform 0.28s ease;
}

.fade-y-enter,
.fade-y-leave-to {
    opacity: 0;
    transform: translateY(10px);
}

.hero ::v-deep .el-carousel__container {
    max-height: 100vh;
    min-height: 280px;
}


@media screen and (max-width: 992px) {
    .product-panel,
    .grid {
        grid-template-columns: 1fr;
    }

    .head {
        flex-direction: column;
        align-items: flex-start;
    }

    .switcher {
        justify-content: flex-start;
    }

}

@media screen and (max-width: 768px) {
    .wrap {
        width: calc(100% - 24px);
    }

    .tabs {
        row-gap: 10px;
    }

    .hero-text {
        padding: 0 40px;
    }

    .product-panel {
        gap: 0;
    }

    .hero-arrow {
        width: 38px;
        height: 38px;
    }

    .hero-arrow-left {
        left: 10px;
    }

    .hero-arrow-right {
        right: 10px;
    }

    .hero-dots-bar {
        bottom: 12px;
    }

    .product,
    .about {
        padding: 48px 0;
    }

    .left {
        padding: 8px 40px;
    }

    .right {
        padding: 18px 56px;
        min-height: 160px;
    }

    .point {
        font-size: 14px;
    }

    .mask {
        padding: 52px 20px;
    }

    .card {
        padding: 20px 16px 24px;
    }

    .about {
        padding-bottom: 0px;
    }

    .tabs button {
        min-height: 52px;
        padding: 0 10px 12px;
        line-height: 1.5;
        white-space: normal;
    }

}

@media screen and (max-width: 500px) {
    .tabs button {
        width: calc(25% - 6px);
        font-size: 15px;
        padding: 0 6px 12px;
    }
}

@media (prefers-reduced-motion: reduce) {
    .observe,
    .fade-y-enter-active,
    .fade-y-leave-active,
    .hero-arrow,
    .dots button,
    .tabs button,
    .tabs button::after,
    .img-arrow,
    .more,
    .switcher button {
        transition: none !important;
    }

    .hero ::v-deep .el-carousel__item.is-active .hero-text {
        animation: none !important;
    }
}
</style>
